<div class='sms-model-height'>
  <app-sms-system-reports [map] = "map"></app-sms-system-reports> 
</div>